import type { ModulesAndAgendasState } from '../index';
import { moveTabSections } from 'utils/section/tabSection';

interface Payload {
  fromNumber: number;
  toNumber: number;
}

export const reorderTabSections = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { fromNumber, toNumber } = payload;

  const nextTabSections = moveTabSections(state.tabSections, fromNumber, toNumber);

  if (!nextTabSections) return;

  state.tabSections = nextTabSections;
};
